import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./index.css";

// Expose Zustand stores on window for Playwright e2e tests (dev only)
if (import.meta.env.DEV) {
  Promise.all([
    import("./stores/editorStore"),
    import("./stores/engineStore"),
    import("./stores/uiStore"),
    import("./stores/debugStore"),
    import("./stores/aiStore"),
  ]).then(([editor, engine, ui, debug, ai]) => {
    (window as unknown as Record<string, unknown>).__ZUSTAND_STORES__ = {
      editorStore: editor.useEditorStore,
      engineStore: engine.useEngineStore,
      uiStore: ui.useUIStore,
      debugStore: debug.useDebugStore,
      aiStore: ai.useAIStore,
    };
  });
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- React root element guaranteed by index.html
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
